var styles = {"Heading":"_6CmGOeaIbZg-","level1":"Elw-bGPz0E4-","level2":"kt5-OzrF-wM-","level3":"XF3er572Ne8-","level4":"lkSR-y-fomk-","start":"k6c6xu-mtmA-","center":"_0yV2Agig-ZI-","multiline":"_3oE8rHB-8ac-"};

export { styles as default };
//# sourceMappingURL=Heading.module.css.js.map
